export const FETCH_NOTICES_INSTANCE_START = 'FETCH_NOTICES_INSTANCE_START';
export const FETCH_NOTICES_INSTANCE_ERROR = 'FETCH_NOTICES_INSTANCE_ERROR';
export const RECEIVE_NOTICES_INSTANCE = 'RECEIVE_NOTICES_INSTANCE';
export const CLEAR_NOTICES_INSTANCE_STORE = 'CLEAR_NOTICES_INSTANCE_STORE';



// WEBPACK FOOTER //
// ./src/store/modules/notices/mutation-types.js